<template>
    <eqt-table @refresh="refresh" @delete="deleteItem" :total="total" :loading="loading" :title="$t('Pages.DocumentTypes.title')" :subtitle="$t('Common.table_subtitle')" :items="items" :headers="headers" hideShowBtn hideEditBtn>
        <template slot="items" slot-scope="{ item }">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.duration }}</td>
        </template>
        <template slot="action-items" slot-scope="{ item }">
            <v-tooltip top>
              <v-btn slot="activator" class="mx-0" small flat icon color="warning" @click="editItem(item)">
                <v-icon  small>edit</v-icon>
              </v-btn>
              <span>{{$t('Core.Fields.edit')}}</span>
            </v-tooltip>
        </template>
    </eqt-table>
</template>

<script>
  import i18n from '@/i18n'
  import EqtTable from '../../components/core/Table'
  export default {
    name: "document-types-table",
    components: {EqtTable},
    props: {
      items: {
        type: Array,
        required: true
      },
      total: {
          type: Number,
          default: 0,
      },
      loading: {
          type: Boolean,
          required: true
      }
    },
    data: () => ({
      headers: [
        {
          sortable: true,
          text: '#',
          value: 'id'
        },
        {
          sortable: true,
          text: i18n.t('Pages.DocumentTypes.model.name'),
          value: 'name'
        },
        {
          sortable: true,
          text: i18n.t('Pages.DocumentTypes.model.description'),
          value: 'description'
        },
        {
          sortable: false,
          text: i18n.t('Pages.DocumentTypes.model.duration'),
          value: 'duration'
        },
      ],
    }),
    methods: {
      refresh(data){
        this.$emit('refresh', data);
      },
      editItem(item) {
        this.$emit('edit', item);
      },
      deleteItem(item){
        this.$emit('delete', item);
      }
    }
  }
</script>

<style scoped>

</style>